import {
  buttonClasses,
  circularProgressClasses,
  Components,
  Theme,
} from "@mui/material";

declare module "@mui/material/Button" {
  interface ButtonPropsSizeOverrides {
    extraSmall: true;
  }
}

export const MuiButton: Components<Omit<Theme, "MuiButton">>["MuiButton"] = {
  variants: [
    {
      props: { size: "extraSmall" },
      style: {
        padding: "6px 8px",
        fontSize: 12,
        lineHeight: "12px",
        borderRadius: 6,

        [`& .${buttonClasses.icon} svg`]: {
          width: 16,
          height: 16,
          paddingLeft: 4,
        },
      },
    },
  ],
  defaultProps: {
    disableElevation: true,
    variant: "contained",
  },
  styleOverrides: {
    root: {
      textTransform: "none",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      [`& .${buttonClasses.icon} svg`]: {
        width: 20,
        height: 20,
      },
    },

    sizeSmall: {
      padding: "8px 12px",
      fontSize: 12,
      lineHeight: "12px",
      borderRadius: 6,

      [`& .${circularProgressClasses.root}`]: {
        marginTop: -2,
        marginBottom: -2,
      },
    },

    sizeMedium: {
      minHeight: 44,
      padding: "14px 24px",
      fontSize: 16,
      lineHeight: "16px",

      [`& .${circularProgressClasses.root}`]: {
        marginTop: -2,
        marginBottom: -2,
      },
    },

    sizeLarge: {
      padding: "18px 24px",
      fontSize: 16,
      lineHeight: "16px",

      [`& .${circularProgressClasses.root}`]: {
        marginTop: -2,
        marginBottom: -2,
      },
    },

    containedPrimary: ({ theme: { palette } }) => ({
      background: palette.secondary.contrastText,
      color: palette.secondary.main,
      "&:hover": {
        background: "#434343",
      },
      "&.Mui-disabled": {
        backgroundColor: "#E0E0E0",
        color: "#9E9E9E",
      },
    }),

    outlinedPrimary: ({ theme: { palette } }) => ({
      background: palette.common.white,
      border: `1px solid ${palette.secondary.contrastText}`,
      color: palette.secondary.contrastText,
      "&:hover": {
        background: "#fcfcfc",
      },
      "&.Mui-disabled": {
        background: "rgba(0, 0, 0, 0.12)",
        color: "#9E9E9E",
      },
    }),

    textPrimary: ({ theme: { palette } }) => ({
      "&:hover": {
        background: palette.main[50],
      },
    }),
  },
};
